document.addEventListener("DOMContentLoaded", () => {
    const cards = document.querySelectorAll(".support__card");

    cards.forEach(card => {
        const icon = card.querySelector(".support__icon--desc");
        if (!icon) return;

        icon.setAttribute("trigger", "hover");

        card.addEventListener("mouseenter", () => {
            icon.setAttribute("trigger", "loop");
        });

        card.addEventListener("mouseleave", () => {
            icon.setAttribute("trigger", "hover");
        });
    });
});
